import { createTheme } from '@material-ui/core/styles';
import { baseTheme, pantonFonts } from './common';
import BackgroundLightJpg from './BackgroundLightJpg';

const defaultTextColor = 'rgba(50,50,0,0.87)';
const defaultBackgroundColor = 'rgb(245,245,245)';
//const backgroundGradient = 'linear-gradient(0deg, #012531, #023140)';
const defaultBorderColor = 'hsla(195, 75%, 50%, 0.25)';
const pantonCommon = {
	color: defaultTextColor,
	fontSize: '1rem',
	lineHeight: 1,
};
const textColors = {
	primary: 'rgba(0,0,0,1)',
	secondary: 'rgba(0,0,0,0.87)',
	tertiary: 'rgba(0,0,0,0.75)',
	caption: 'rgba(0,0,0,0.54)',
	disabled: 'rgba(0,0,0,0.38)',
	hint: 'rgba(0,0,0,0.38)',
};
const textWhiteColors = {
	primary: 'rgba(255,255,255,1)',
	secondary: 'rgba(255,255,255,0.87)',
	tertiary: 'rgba(255,255,255,0.75)',
	caption: 'rgba(255,255,255,0.54)',
	disabled: 'rgba(255,255,255,0.38)',
	hint: 'rgba(255,255,255,0.38)',
};
const scheme = {
	main: '#147ba4',
	darker: '#0b7197',
	dark: '#005a7f',
	lighter: '#1687af',
	light: '#1687af',
	lightest: '#21a8e0'
};

const lightTheme = createTheme({
	name: 'light',
	typography: {
		fontFamily: pantonFonts.panton,
		fontPanton: {
			...pantonCommon,
			fontFamily: pantonFonts.panton,
		},
		fontPantonLight: {
			...pantonCommon,
			fontFamily: pantonFonts.pantonLight,
		},
		fontPantonExtraLight: {
			...pantonCommon,
			fontFamily: pantonFonts.pantonExtraLight,
		},
		fontPantonSemiBold: {
			...pantonCommon,
			fontFamily: pantonFonts.pantonSemiBold,
		},
		h4: {
			color: textColors.secondary,
			fontFamily: pantonFonts.panton,
		},
		h5: {
			color: textColors.secondary,
			fontFamily: pantonFonts.panton,
		},
		body1: {
			color: textColors.secondary,
			fontFamily: pantonFonts.panton,
		},
		body2: {
			color: textColors.secondary,
			fontFamily: pantonFonts.panton,
			fontSize: '0.875rem',
		},
		caption: {
			color: textColors.caption,
			fontFamily: pantonFonts.pantonLight,
		},
	},
	palette: {
		borderColor: scheme.light,
		text: {
			...textColors,
		},
		textBlack: {
			...textColors,
		},
		textWhite: {
			...textWhiteColors,
    },
    textInvert: {
			...textWhiteColors,
    },
	loading: {
		primary: scheme.main,
		secondary: scheme.main
	},	
    primary: {
      main: scheme.main,
      light: scheme.light,
      dark: scheme.dark,
      gradient: scheme.main,
			alt_main: scheme.dark,
		},
    danger: {
      main: '#b0340a',
      light: '#e96538',
      dark: '#7a0000',
		},
    trash: {
      main: "rgba(176, 52, 10,0.5)",
      light: '#e96538',
      dark: '#7a0000',
		},
		buttonPrimary: scheme.lighter,
		buttonSecondary: scheme.lightest,
		buttonMain: scheme.main,
		buttonDark: scheme.dark,
		buttonDarker: scheme.darker,
		buttonLighter: scheme.lighter,
		buttonLight: scheme.light,
		buttonLightest: scheme.lightest,
		buttonHoverText: textColors.main,
	},
	component: {
		appbarToolbarRoot: {
			backgroundColor: scheme.lightest,
		},
		border: `1px solid ${scheme.lighter}`,
		borderMust: `1px solid ${defaultBorderColor}`,
		borderDotted: `1px dotted ${defaultBorderColor}`,
		breadcrumbs: {
			background: 'rgba(255,255,255,0.5)',
			borderBottom: `1px solid ${defaultBorderColor}`,
			color: textColors.primary,
		},
		buttonSwitchColorInitial: scheme.light,
		dashboardButtonColorDefault: {
			background: 'rgba(255,255,255,0.75)',
			border: `1px solid ${defaultBorderColor}`,
		},
		dashboardButtonColorSecondary: {
			background: 'rgba(255,255,255,0.75)',
			border: `1px solid ${defaultBorderColor}`,
		},
		dashboardButtonBackdrop: {
			borderRadius: 4,
		},
		dashboardButtonPaper: {
			alignContent: 'center',
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
			padding: baseTheme.spacing(1.5),
			minHeight: 100,
			width: '100%',
		},
		dashboardButtonIcon: {
			color: 'hsla(195, 75%, 50%, 0.75)',
		},
		dashboardButtonPrimary: {
			fontFamily: pantonFonts.pantonLight,
		},
		dashboardButtonSecondary: {
			color: textColors.tertiary,
			minHeight: 22,
		},
		dashboardClockInListPaper: {
			backgroundColor: 'initial',
			border: `1px solid ${defaultBorderColor}`,
		},
		dashboardClockInCollapsed: {
			backgroundColor: scheme.lighter,
			borderRadius: '2px',
		},
		dashboardPaper: {
			background: 'rgba(255,255,255,0.75)',
			border: `1px solid ${defaultBorderColor}`,
			boxSizing: 'border-box',
		},
		dialogPaper: {
			background: defaultBackgroundColor,
			position: 'initial',
			overflow: 'initial',
		},
		dialogPaperFullscreen: {
			backgroundColor: defaultBackgroundColor,
		},
		dialogHeader: {
			backgroundColor: scheme.light,
		},
		dialogHeaderCloseButton: {
			borderLeft: `1px solid ${defaultBorderColor}`,
			padding: baseTheme.spacing(1),
		},
		drawerPaper: {
			background: 'none',
		},
		drawerPaperMobile: {
			background: defaultBackgroundColor,
		},
		drawerButton: {
			background: scheme.light,
			color: textWhiteColors.secondary,
		},
		imagePlaceholder: '/images/image_placeholder_white.png',
		infoContent: {
			background: 'rgba(255,255,255,0.5)',
		},
		navIcon: {
			color: 'hsla(195, 75%, 50%, 0.75)',
		},
		navTab: {
			//backgroundColor: scheme.dark,
			color: textColors.tertiary,
			background: 'rgba(225,225,225,0.5)',
			borderLeft: `1px solid ${defaultBorderColor}`,
			borderRight: `1px solid ${defaultBorderColor}`,
			borderTop: `1px solid ${defaultBorderColor}`,
			marginBottom: -1,
			zIndex: 1,
		},
		navTabTitle: {

		},
		navTabActive: {
			background: 'rgba(255,255,255,0.75)',
			borderBottom: `1px solid white`,
			color: textColors.primary,
		},
		projectClockButtonPaper: {
			backgroundColor: scheme.buttonLight,
		},
		projectsListButton: {
      background: 'rgba(255,255,255,0.75)',
			border: `1px solid ${defaultBorderColor}`,
			fontFamily: pantonFonts.pantonLight,
		},
		projectsListButtonFirst: {
			color: 'hsla(195, 75%, 50%, 0.75)',
			fontFamily: pantonFonts.panton,
		},
		projectsListButtonMiddle: {
			borderLeft: 'none',
		},
		projectsListButtonLast: {
			borderLeft: 'none',
		},
		projectsListButtonTitle: {
			fontFamily: pantonFonts.panton,
		},
		record: {
			color: textColors.secondary,
		},
		recordBackface: {
			backgroundColor: 'rgb(0,0,0)',
		},
		recordWork: {
			background: 'rgba(0,0,0,0.1)',
		},
		recordWorkActive: {
			background: 'hsla(120, 75%, 70%,0.5)',
		},
		recordBreak: {
			background: 'hsla(0, 50%, 70%,0.5)',
		},
		recordShift: {
			background: 'hsla(30, 50%, 70%,0.5)',
		},
		recordAbsence: {
			background: 'hsla(210, 50%, 70%,0.5)',
		},
		recordBenefit: {
			background: 'hsla(90, 50%, 70%,0.5)',
		},
		recordRide: {
			background: 'hsla(180, 50%, 70%,0.5)',
		},
		recordNegative: {
			background: 'hsla(240, 50%, 70%,0.5)',
		},
		recordItem: {
			background: 'hsla(60, 50%, 70%,0.5)',
		},
		sideBadge: {
			border: `2px solid ${scheme.lightest}`,
		},
		snackBar: {
			background: scheme.main,
		},
		workCalendarWeekPaper: {
			backgroundColor: '#FFFFFF',
		},
		invoicePrimary: {
			backgroundColor: scheme.main
		},
		invoiceSecondary: {
			backgroundColor: scheme.lighter
		}		
	},
  overrides: {
    MuiCssBaseline: {
      '@global': {
				html: {
					background: `url("data:image/jpg;base64,${BackgroundLightJpg}") no-repeat center center fixed`,
					backgroundSize: 'cover',
					color: defaultTextColor,
					fontSmoothing: 'initial',
				},
				body: {
					background: 'none',
					backgroundColor: 'initial',
					color: defaultTextColor,
					fontWeight: 'initial',
				},
      },
		},
		MuiAppBar: {
			colorPrimary: {
				backgroundColor: scheme.lightest,
			}
		},
    MuiButton: {
      root: {
        borderRadius: '0',
      }
    },
    MuiOutlinedInput: {
			root: {
				position: 'relative',
				'& $notchedOutline': {
					borderColor: 'rgba(0, 0, 0, 0.5)',
				},
				'&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
					borderColor: '#4A90E2',
					// Reset on touch devices, it doesn't add specificity
					'@media (hover: none)': {
						borderColor: 'rgba(0, 0, 0, 0.23)',
					},
				},
				'&$focused $notchedOutline': {
					borderColor: '#4A90E2',
					borderWidth: 1,
				},
			},
    },
    MuiFormLabel: {
			root: {
				'&$focused': {
					color: '#4A90E2'
				}
			}
		},
		MuiMenuItem: {
			root: {
				fontSize: '0.87rem',
				minHeight: baseTheme.spacing(4)
			}
		}
  },
});

export default lightTheme;